// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 148) return "user-collection.ac7bef1629750991b3ee.css";
	// return url for filenames based on template
	return "" + chunkId + "." + {"34":"e1bab904b0f44ddabe54","197":"9f21b68e434db94209f4","451":"8b6680113317ae2e8dc6"}[chunkId] + ".css";
};